export default class MobileBlogMenu {
    constructor(element) {
        this.selector = element;

        this.openMenu();
    }

    openMenu() {
        const menu = this.selector.querySelector('[data-menu]');
        const selector = this.selector.querySelector('[data-menu-selector]');

        selector.addEventListener('click', () => {
            this.selector.classList.toggle('active');

            if (this.selector.classList.contains('active')) {
                menu.style.maxHeight = `${menu.scrollHeight}px`;
            } else {
                menu.style.maxHeight = 0;
            }
        });
    }
}